import { gql, useQuery, WatchQueryFetchPolicy } from '@apollo/client';
import { UpcomingAppointments } from './__generated__/UpcomingAppointments';

export const GET_UPCOMING_APPOINTMENTS = gql`
  query UpcomingAppointments {
    upcomingAppointments {
      id
      dateFrom
      status
      service {
        id
        name
        serviceGroup
        serviceSlug
      }
      mode
      counsellorName
      timeZone
    }
  }
`;

interface UseGetUpcomingEAPAppointmentsOptions {
  /**
   * Defaults to `network-only`, which `/book` relies on: it shows a single
   * page-level loader anyway, so it prefers appointments that are guaranteed
   * fresh after a booking or cancellation.
   *
   * Callers that render alongside already-visible content should pass
   * `cache-and-network` instead, so a remount serves the cached appointments
   * immediately rather than falling back to a loading state.
   */
  fetchPolicy?: WatchQueryFetchPolicy;
}

export const useGetUpcomingEAPAppointments = ({
  fetchPolicy = 'network-only',
}: UseGetUpcomingEAPAppointmentsOptions = {}) => {
  const { data, loading, error, refetch } = useQuery<UpcomingAppointments>(
    GET_UPCOMING_APPOINTMENTS,
    {
      fetchPolicy,
    },
  );

  return { data, loading, error, refetch };
};
